import {
  IMAGE_UPLOAD_REQUESTED,
  IMAGE_UPLOAD_SUCCEEDED,
  IMAGE_UPLOAD_FAILED,
  IMAGE_CONVERT_REQUESTED,
  IMAGE_CONVERT_SUCCEEDED,
  IMAGE_CONVERT_FAILED,
  SAVE_IMAGE_INFO,
  DELETE_IMAGE,
  SAVE_IMAGE_DATA,
  SET_IMAGE_ERROR,
  SET_SAMPLE_IMAGE,
  SET_IMAGE_SRC,
} from '../types/image.types'

export const imageUploadAction = (image) => ({ type: IMAGE_UPLOAD_REQUESTED, payload: { image }})
export const imageUploadActionSuccess = (data) => ({ type: IMAGE_UPLOAD_SUCCEEDED, payload: data })
export const setSampleImage = (data) => ({ type: SET_SAMPLE_IMAGE, payload: data })
export const setImageSrc = (imageSrc) => ({ type: SET_IMAGE_SRC, payload: imageSrc })
export const imageUploadActionFailed = (error) => ({ type: IMAGE_UPLOAD_FAILED, payload: error })
export const deleteImage = () => ({ type: DELETE_IMAGE })
export const saveImageInfo = (name, format, type) => ({ type: SAVE_IMAGE_INFO, payload: { name, format, type } })
export const imageConvertAction = (data) => ({ type: IMAGE_CONVERT_REQUESTED, payload: data })
export const imageConvertActionSuccess = (imageToDownload, imageSize) => ({
  type: IMAGE_CONVERT_SUCCEEDED,
  payload: { imageToDownload, imageSize },
})
export const imageConvertActionFailed = (error) => ({ type: IMAGE_CONVERT_FAILED, payload: error })
export const saveImageData = (data) => ({ type: SAVE_IMAGE_DATA, payload: data })
export const setImageError = (status) => ({ type: SET_IMAGE_ERROR, payload: status })
